export const DOWNLOAD_LINK = "https://onelink.to/amxb7p";
export const LOGO_URL = "/pamapay-logo.png";

export const SOCIALS = {
  instagram: "https://www.instagram.com/pamapay_app?igsh=OWYxZHlnY2FuZWt2",
  twitter: "https://x.com/PamaPay_App?t=X63HIXs8VJ-Kfvgqr4MNAg&s=09",
  youtube: "https://www.youtube.com/@pamapay",
  linkedin: "https://www.linkedin.com/company/pamapayapp",
  facebook: "https://www.facebook.com/people/PamaPay/61583512963293/",
  telegram: "https://t.me/+tB2cN1xNHmhhZDJk",
  whatsapp: "https://wa.me/message/2RJ5NF6PRMHZB1",
};

export const CONTACT = {
  email: "Hello@akkayglobal.com",
  phone: "+234-8099524956",
  company: "Akkay Tanko Global Services Ltd.",
};

export const LEGAL = {
  terms: "https://mypamapay.com/terms-of-use",
  privacy: "https://mypamapay.com/privacy-policy",
  faq: "https://mypamapay.com/faq",
};

export const SUPPORTED_COINS = [
  { sym: "BTC", name: "Bitcoin", color: "#F7931A" },
  { sym: "ETH", name: "Ethereum", color: "#627EEA" },
  { sym: "USDT", name: "Tether", color: "#26A17B" },
  { sym: "USDC", name: "USD Coin", color: "#2775CA" },
  { sym: "BNB", name: "BNB", color: "#F3BA2F" },
  { sym: "SOL", name: "Solana", color: "#9945FF" },
  { sym: "TRX", name: "Tron", color: "#EF0027" },
  { sym: "XRP", name: "XRP", color: "#23292F" },
  { sym: "DOGE", name: "Dogecoin", color: "#C2A633" },
  { sym: "LTC", name: "Litecoin", color: "#345D9D" },
  { sym: "MATIC", name: "Polygon", color: "#8247E5" },
  { sym: "TON", name: "Toncoin", color: "#0098EA" },
];

export const TESTIMONIALS = [
  { handle: "@adekunle.eth", body: "Cashed out 1,200 USDT and the naira hit my GTB account before I even closed the app. PamaPay is wild fast.", rating: 5 },
  { handle: "@chinwe.codes", body: "Their rate match is real. I screenshotted a competitor's rate and they beat it on the spot.", rating: 5 },
  { handle: "@tundeOTC", body: "Been using PamaPay for OTC bulk swaps — support replies in under 2 minutes. Genuinely the fastest.", rating: 5 },
  { handle: "@zeezah_x", body: "Finally an app that doesn't make crypto-to-naira feel like a side quest. Three taps, money in, done.", rating: 5 },
  { handle: "@dami.builds", body: "Referred 4 friends and the referral naira is hitting consistently. Best part of the app honestly.", rating: 5 },
  { handle: "@kunleayo", body: "I trade BTC daily and PamaPay's rates beat every P2P platform I've tried. No cap.", rating: 5 },
];

export const FAQS = [
  {
    q: "What is PamaPay?",
    a: "PamaPay is a mobile app that lets you instantly convert your cryptocurrency (BTC, ETH, USDT, BNB, SOL and more) directly into Nigerian Naira and receive it in your bank account — without P2P stress.",
  },
  {
    q: "How fast are conversions processed?",
    a: "Most conversions complete in under 60 seconds. Bank credit timing depends on your bank, but funds typically land within minutes.",
  },
  {
    q: "What is the Rate Match guarantee?",
    a: "Show us any verified competitor offering a better rate on a comparable trade and PamaPay will beat it. Send a screenshot via in-app support and we'll do the rest.",
  },
  {
    q: "Is PamaPay safe?",
    a: "Yes. PamaPay uses bank-grade encryption, regulated banking partners, and rigorous KYC. Your funds and identity are protected end-to-end.",
  },
  {
    q: "Do I need to complete KYC?",
    a: "Basic KYC (BVN + ID) is required to comply with Nigerian regulations and protect your funds. The verification flow takes 2-3 minutes.",
  },
  {
    q: "How does the referral program work?",
    a: "You earn ₦1 for every $1 a person you referred trades on PamaPay. Refer one active trader doing $1,000/month and you earn ₦1,000/month — passive.",
  },
  {
    q: "Do you support bulk / OTC trades?",
    a: "Yes — through AkkayGlobal OTC. For trades above standard limits, contact our WhatsApp OTC desk for personalised rates and concierge support.",
  },
  {
    q: "Which coins are supported?",
    a: "BTC, ETH, USDT (TRC20/ERC20), USDC, BNB, SOL, TRX, XRP, LTC, DOGE, MATIC, TON and more added regularly.",
  },
];
